import { useEffect, useState } from 'react';

/*
  Which day and dusk murals should load. The visible one loads straight away.
  The hidden one waits until the page has settled, so it never competes with
  first paint but is ready for a smooth theme change.
*/
export default function useThemeMural(dark) {
  const [settled, setSettled] = useState(false);

  useEffect(() => {
    let timer;
    const wait = () => { timer = setTimeout(() => setSettled(true), 1500); };
    if (document.readyState === 'complete') wait();
    else window.addEventListener('load', wait, { once: true });
    return () => {
      clearTimeout(timer);
      window.removeEventListener('load', wait);
    };
  }, []);

  return { day: settled || !dark, dusk: settled || dark };
}
